import httpClient from './httpClient';

const prefix = 'salary'

export default {
    async isReadSalaryId(id){
        const { data } = await httpClient({ requiresAuth: true }).put(`${prefix}/is_read/`+id)
        return data
    },
    async getSalaryAll(){
        const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getSalaryAll`)
        return data
    },
    async getSalaryById(id){
        const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getSalaryById/`+id)
        return data
    },
    async getClaimStatusAll(){
        const { data } = await httpClient({ requiresAuth: true }).get(`${prefix}/getClaimStatusAll`)
        return data
    },
    async createSalary(body){
        const { data } = await httpClient({ requiresAuth: true }).post(`${prefix}/createSalary`,body)
        return data
    },

    async updateSalary(body,id){
        const { data } = await httpClient({ requiresAuth: true }).put(`${prefix}/updateSalary/${id}`,body)
        return data
    }
}
